import React from 'react';
import { Modal, Table, Badge, Alert } from 'react-bootstrap';
import { formatDateTimeWithoutHour } from '../../../../utils/helper';
import { objectTrangThaiCME } from '../../../../utils/define';
import { BaseGatewayImage } from '../../../../utils/apiUrl';
import UserInfoCell from '../duyetHoSo/UserInfoCell';
import { userManager } from '../../../../utils/oidc';

const CMEHoSoDetailModal = ({ isOpen, handleClose, data }) => {
    if (!data) return null;

    const [oidcProfile, setOidcProfile] = React.useState(null);

    React.useEffect(() => {
        if (isOpen) {
            const fetchOidc = async () => {
                const profile = await userManager.getUser().then(user => user ? user.profile : null);
                if (profile) setOidcProfile(profile);
            };
            fetchOidc();
        }
    }, [isOpen]);

    const getStatusBadge = (status) => {
        const found = objectTrangThaiCME.find(x => x.value === status);
        return found ? <Badge variant={found.color}>{found.label}</Badge> : <Badge variant="secondary">N/A</Badge>;
    };

    const files = (data.dinhKemFiles?.$values || data.dinhKemFiles || data.DinhKemFiles?.$values || data.DinhKemFiles || []).filter(f => !!f);

    return (
        <Modal
            show={isOpen}
            onHide={handleClose}
            centered
            size="lg"
            style={{ zIndex: '9999' }}
        >
            <Modal.Header closeButton className="bg-info text-white">
                <Modal.Title style={{ fontSize: '1.1rem' }}>
                    <i className="fas fa-file-alt mr-2"></i>Chi tiết hồ sơ CME
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table bordered size="sm">
                    <tbody>
                        <tr>
                            <td className="font-weight-bold bg-light" style={{ width: '200px' }}>Cán bộ nộp</td>
                            <td>
                                {oidcProfile && String(oidcProfile.sub).toLowerCase() === String(data.userId).toLowerCase() ? (
                                    <div>
                                        <div className="font-weight-bold text-dark">{oidcProfile.name}</div>
                                        <small className="text-muted">{oidcProfile.preferred_username || 'Chưa cập nhật mã'}</small>
                                    </div>
                                ) : (
                                    <UserInfoCell userId={data.userId} mode="name" />
                                )}
                            </td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold bg-light">Nội dung hoạt động</td>
                            <td>{data.noiDung}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold bg-light">Danh mục</td>
                            <td>{data.tenDanhMuc} - {data.tenTieuMuc}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold bg-light">Vai trò</td>
                            <td className="text-info">{data.vaiTro || <span className="text-muted">N/A</span>}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold bg-light">Số lượng</td>
                            <td>{data.soLuong}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold bg-light">Số giờ tín chỉ</td>
                            <td className="text-primary font-weight-bold">{data.soGioTinChi} giờ</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold bg-light">Thời gian</td>
                            <td>{formatDateTimeWithoutHour(data.tuNgay)} — {formatDateTimeWithoutHour(data.denNgay)}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold bg-light">Địa điểm</td>
                            <td>{data.diaDiem || <span className="text-muted">Không có</span>}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold bg-light">Năm tích lũy</td>
                            <td>{data.namTichLuy}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bold bg-light">Trạng thái</td>
                            <td>{getStatusBadge(data.trangThai)}</td>
                        </tr>
                        {data.nguoiDuyet && (
                            <tr>
                                <td className="font-weight-bold bg-light">Người duyệt</td>
                                <td>{data.nguoiDuyet}</td>
                            </tr>
                        )}
                        {data.ngayDuyet && (
                            <tr>
                                <td className="font-weight-bold bg-light">Ngày duyệt</td>
                                <td>{formatDateTimeWithoutHour(data.ngayDuyet)}</td>
                            </tr>
                        )}
                    </tbody>
                </Table>

                {data.lyDoTuChoi && (
                    <Alert variant="danger" className="mt-3">
                        <i className="fas fa-exclamation-triangle mr-2"></i>
                        <strong>Lý do từ chối:</strong> {data.lyDoTuChoi}
                    </Alert>
                )}

                {files.length > 0 && (
                    <div className="mt-3">
                        <h6 className="font-weight-bold"><i className="fas fa-paperclip mr-2"></i>File minh chứng đính kèm</h6>
                        <ul className="list-unstyled">
                            {files.map((file, idx) => (
                                <li key={idx} className="mb-1 d-flex align-items-center">
                                    <i className="fas fa-file-alt text-muted mr-2"></i>
                                    <a href={`${BaseGatewayImage}${file?.filePath || file?.fileManager?.filePath}`} target="_blank" rel="noopener noreferrer" className="text-primary">
                                        {file?.name || file?.fileManager?.name || `Tệp minh chứng ${idx + 1}`}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={handleClose}>Đóng</button>
            </Modal.Footer>
        </Modal>
    );
};

export default CMEHoSoDetailModal;
